import {FAIRPLAY_CERTIFICATE_URL} from '../../../../donotinclude';

import IConfigDrm from './Interfaces/IConfigDrm';

class ConfigDrm implements IConfigDrm {
    public authToken              = '';
    public fairplayCertificateUrl = FAIRPLAY_CERTIFICATE_URL;
    public licenseUrl             = '';
    public releasePid             = '';

    constructor() {
        Object.seal(this);
    }
}

export default ConfigDrm;